export const confirmationSelector = (state) => state.get('confirmation');
